// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.6
//   protoc               unknown
// source: photon/imessage/v1/group_types.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { Timestamp } from "../../../google/protobuf/timestamp.js";
import { SingleServiceAddressInfo } from "./address_types.js";

export const protobufPackage = "photon.imessage.v1";

export interface GroupDisplayNameChanged {
  displayName: string;
}

export interface GroupParticipantAdded {
  participant: SingleServiceAddressInfo | undefined;
}

/**
 * Participant removed by another member (kicked). The actor on the
 * envelope is the remover, distinct from `participant`.
 */
export interface GroupParticipantRemoved {
  participant: SingleServiceAddressInfo | undefined;
}

/**
 * Participant voluntarily left the group. The actor on the envelope and
 * `participant` are the same.
 */
export interface GroupParticipantLeft {
  participant: SingleServiceAddressInfo | undefined;
}

/**
 * Icon mutations carry no payload. Fetch the new bytes via
 * `GroupService.GetIcon` after observing the event.
 */
export interface GroupIconChanged {
}

export interface GroupIconRemoved {
}

/**
 * A discrete state transition observed for a group chat.
 *
 * `actor` is the participant whose action produced the change; absent when
 * Apple's stack does not surface one (e.g. icon mutations from the local
 * device).
 */
export interface GroupChangeEvent {
  chatGuid: string;
  occurredAt: Date | undefined;
  actor?: SingleServiceAddressInfo | undefined;
  isFromMe: boolean;
  displayNameChanged?: GroupDisplayNameChanged | undefined;
  participantAdded?: GroupParticipantAdded | undefined;
  participantRemoved?: GroupParticipantRemoved | undefined;
  participantLeft?: GroupParticipantLeft | undefined;
  iconChanged?: GroupIconChanged | undefined;
  iconRemoved?: GroupIconRemoved | undefined;
}

function createBaseGroupDisplayNameChanged(): GroupDisplayNameChanged {
  return { displayName: "" };
}

export const GroupDisplayNameChanged: MessageFns<GroupDisplayNameChanged> = {
  encode(message: GroupDisplayNameChanged, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.displayName !== "") {
      writer.uint32(10).string(message.displayName);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GroupDisplayNameChanged {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGroupDisplayNameChanged();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.displayName = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GroupDisplayNameChanged {
    return {
      displayName: isSet(object.displayName)
        ? globalThis.String(object.displayName)
        : isSet(object.display_name)
        ? globalThis.String(object.display_name)
        : "",
    };
  },

  toJSON(message: GroupDisplayNameChanged): unknown {
    const obj: any = {};
    if (message.displayName !== "") {
      obj.displayName = message.displayName;
    }
    return obj;
  },

  create(base?: DeepPartial<GroupDisplayNameChanged>): GroupDisplayNameChanged {
    return GroupDisplayNameChanged.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GroupDisplayNameChanged>): GroupDisplayNameChanged {
    const message = createBaseGroupDisplayNameChanged();
    message.displayName = object.displayName ?? "";
    return message;
  },
};

function createBaseGroupParticipantAdded(): GroupParticipantAdded {
  return { participant: undefined };
}

export const GroupParticipantAdded: MessageFns<GroupParticipantAdded> = {
  encode(message: GroupParticipantAdded, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.participant !== undefined) {
      SingleServiceAddressInfo.encode(message.participant, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GroupParticipantAdded {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGroupParticipantAdded();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.participant = SingleServiceAddressInfo.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GroupParticipantAdded {
    return {
      participant: isSet(object.participant) ? SingleServiceAddressInfo.fromJSON(object.participant) : undefined,
    };
  },

  toJSON(message: GroupParticipantAdded): unknown {
    const obj: any = {};
    if (message.participant !== undefined) {
      obj.participant = SingleServiceAddressInfo.toJSON(message.participant);
    }
    return obj;
  },

  create(base?: DeepPartial<GroupParticipantAdded>): GroupParticipantAdded {
    return GroupParticipantAdded.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GroupParticipantAdded>): GroupParticipantAdded {
    const message = createBaseGroupParticipantAdded();
    message.participant = (object.participant !== undefined && object.participant !== null)
      ? SingleServiceAddressInfo.fromPartial(object.participant)
      : undefined;
    return message;
  },
};

function createBaseGroupParticipantRemoved(): GroupParticipantRemoved {
  return { participant: undefined };
}

export const GroupParticipantRemoved: MessageFns<GroupParticipantRemoved> = {
  encode(message: GroupParticipantRemoved, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.participant !== undefined) {
      SingleServiceAddressInfo.encode(message.participant, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GroupParticipantRemoved {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGroupParticipantRemoved();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.participant = SingleServiceAddressInfo.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GroupParticipantRemoved {
    return {
      participant: isSet(object.participant) ? SingleServiceAddressInfo.fromJSON(object.participant) : undefined,
    };
  },

  toJSON(message: GroupParticipantRemoved): unknown {
    const obj: any = {};
    if (message.participant !== undefined) {
      obj.participant = SingleServiceAddressInfo.toJSON(message.participant);
    }
    return obj;
  },

  create(base?: DeepPartial<GroupParticipantRemoved>): GroupParticipantRemoved {
    return GroupParticipantRemoved.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GroupParticipantRemoved>): GroupParticipantRemoved {
    const message = createBaseGroupParticipantRemoved();
    message.participant = (object.participant !== undefined && object.participant !== null)
      ? SingleServiceAddressInfo.fromPartial(object.participant)
      : undefined;
    return message;
  },
};

function createBaseGroupParticipantLeft(): GroupParticipantLeft {
  return { participant: undefined };
}

export const GroupParticipantLeft: MessageFns<GroupParticipantLeft> = {
  encode(message: GroupParticipantLeft, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.participant !== undefined) {
      SingleServiceAddressInfo.encode(message.participant, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GroupParticipantLeft {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGroupParticipantLeft();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.participant = SingleServiceAddressInfo.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GroupParticipantLeft {
    return {
      participant: isSet(object.participant) ? SingleServiceAddressInfo.fromJSON(object.participant) : undefined,
    };
  },

  toJSON(message: GroupParticipantLeft): unknown {
    const obj: any = {};
    if (message.participant !== undefined) {
      obj.participant = SingleServiceAddressInfo.toJSON(message.participant);
    }
    return obj;
  },

  create(base?: DeepPartial<GroupParticipantLeft>): GroupParticipantLeft {
    return GroupParticipantLeft.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GroupParticipantLeft>): GroupParticipantLeft {
    const message = createBaseGroupParticipantLeft();
    message.participant = (object.participant !== undefined && object.participant !== null)
      ? SingleServiceAddressInfo.fromPartial(object.participant)
      : undefined;
    return message;
  },
};

function createBaseGroupIconChanged(): GroupIconChanged {
  return {};
}

export const GroupIconChanged: MessageFns<GroupIconChanged> = {
  encode(_: GroupIconChanged, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GroupIconChanged {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGroupIconChanged();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): GroupIconChanged {
    return {};
  },

  toJSON(_: GroupIconChanged): unknown {
    const obj: any = {};
    return obj;
  },

  create(base?: DeepPartial<GroupIconChanged>): GroupIconChanged {
    return GroupIconChanged.fromPartial(base ?? {});
  },
  fromPartial(_: DeepPartial<GroupIconChanged>): GroupIconChanged {
    const message = createBaseGroupIconChanged();
    return message;
  },
};

function createBaseGroupIconRemoved(): GroupIconRemoved {
  return {};
}

export const GroupIconRemoved: MessageFns<GroupIconRemoved> = {
  encode(_: GroupIconRemoved, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GroupIconRemoved {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGroupIconRemoved();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): GroupIconRemoved {
    return {};
  },

  toJSON(_: GroupIconRemoved): unknown {
    const obj: any = {};
    return obj;
  },

  create(base?: DeepPartial<GroupIconRemoved>): GroupIconRemoved {
    return GroupIconRemoved.fromPartial(base ?? {});
  },
  fromPartial(_: DeepPartial<GroupIconRemoved>): GroupIconRemoved {
    const message = createBaseGroupIconRemoved();
    return message;
  },
};

function createBaseGroupChangeEvent(): GroupChangeEvent {
  return {
    chatGuid: "",
    occurredAt: undefined,
    actor: undefined,
    isFromMe: false,
    displayNameChanged: undefined,
    participantAdded: undefined,
    participantRemoved: undefined,
    participantLeft: undefined,
    iconChanged: undefined,
    iconRemoved: undefined,
  };
}

export const GroupChangeEvent: MessageFns<GroupChangeEvent> = {
  encode(message: GroupChangeEvent, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.chatGuid !== "") {
      writer.uint32(10).string(message.chatGuid);
    }
    if (message.occurredAt !== undefined) {
      Timestamp.encode(toTimestamp(message.occurredAt), writer.uint32(18).fork()).join();
    }
    if (message.actor !== undefined) {
      SingleServiceAddressInfo.encode(message.actor, writer.uint32(26).fork()).join();
    }
    if (message.isFromMe !== false) {
      writer.uint32(32).bool(message.isFromMe);
    }
    if (message.displayNameChanged !== undefined) {
      GroupDisplayNameChanged.encode(message.displayNameChanged, writer.uint32(82).fork()).join();
    }
    if (message.participantAdded !== undefined) {
      GroupParticipantAdded.encode(message.participantAdded, writer.uint32(90).fork()).join();
    }
    if (message.participantRemoved !== undefined) {
      GroupParticipantRemoved.encode(message.participantRemoved, writer.uint32(98).fork()).join();
    }
    if (message.participantLeft !== undefined) {
      GroupParticipantLeft.encode(message.participantLeft, writer.uint32(106).fork()).join();
    }
    if (message.iconChanged !== undefined) {
      GroupIconChanged.encode(message.iconChanged, writer.uint32(114).fork()).join();
    }
    if (message.iconRemoved !== undefined) {
      GroupIconRemoved.encode(message.iconRemoved, writer.uint32(122).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GroupChangeEvent {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGroupChangeEvent();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.chatGuid = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.occurredAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.actor = SingleServiceAddressInfo.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.isFromMe = reader.bool();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.displayNameChanged = GroupDisplayNameChanged.decode(reader, reader.uint32());
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.participantAdded = GroupParticipantAdded.decode(reader, reader.uint32());
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.participantRemoved = GroupParticipantRemoved.decode(reader, reader.uint32());
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.participantLeft = GroupParticipantLeft.decode(reader, reader.uint32());
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.iconChanged = GroupIconChanged.decode(reader, reader.uint32());
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.iconRemoved = GroupIconRemoved.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GroupChangeEvent {
    return {
      chatGuid: isSet(object.chatGuid)
        ? globalThis.String(object.chatGuid)
        : isSet(object.chat_guid)
        ? globalThis.String(object.chat_guid)
        : "",
      occurredAt: isSet(object.occurredAt)
        ? fromJsonTimestamp(object.occurredAt)
        : isSet(object.occurred_at)
        ? fromJsonTimestamp(object.occurred_at)
        : undefined,
      actor: isSet(object.actor) ? SingleServiceAddressInfo.fromJSON(object.actor) : undefined,
      isFromMe: isSet(object.isFromMe)
        ? globalThis.Boolean(object.isFromMe)
        : isSet(object.is_from_me)
        ? globalThis.Boolean(object.is_from_me)
        : false,
      displayNameChanged: isSet(object.displayNameChanged)
        ? GroupDisplayNameChanged.fromJSON(object.displayNameChanged)
        : isSet(object.display_name_changed)
        ? GroupDisplayNameChanged.fromJSON(object.display_name_changed)
        : undefined,
      participantAdded: isSet(object.participantAdded)
        ? GroupParticipantAdded.fromJSON(object.participantAdded)
        : isSet(object.participant_added)
        ? GroupParticipantAdded.fromJSON(object.participant_added)
        : undefined,
      participantRemoved: isSet(object.participantRemoved)
        ? GroupParticipantRemoved.fromJSON(object.participantRemoved)
        : isSet(object.participant_removed)
        ? GroupParticipantRemoved.fromJSON(object.participant_removed)
        : undefined,
      participantLeft: isSet(object.participantLeft)
        ? GroupParticipantLeft.fromJSON(object.participantLeft)
        : isSet(object.participant_left)
        ? GroupParticipantLeft.fromJSON(object.participant_left)
        : undefined,
      iconChanged: isSet(object.iconChanged)
        ? GroupIconChanged.fromJSON(object.iconChanged)
        : isSet(object.icon_changed)
        ? GroupIconChanged.fromJSON(object.icon_changed)
        : undefined,
      iconRemoved: isSet(object.iconRemoved)
        ? GroupIconRemoved.fromJSON(object.iconRemoved)
        : isSet(object.icon_removed)
        ? GroupIconRemoved.fromJSON(object.icon_removed)
        : undefined,
    };
  },

  toJSON(message: GroupChangeEvent): unknown {
    const obj: any = {};
    if (message.chatGuid !== "") {
      obj.chatGuid = message.chatGuid;
    }
    if (message.occurredAt !== undefined) {
      obj.occurredAt = message.occurredAt.toISOString();
    }
    if (message.actor !== undefined) {
      obj.actor = SingleServiceAddressInfo.toJSON(message.actor);
    }
    if (message.isFromMe !== false) {
      obj.isFromMe = message.isFromMe;
    }
    if (message.displayNameChanged !== undefined) {
      obj.displayNameChanged = GroupDisplayNameChanged.toJSON(message.displayNameChanged);
    }
    if (message.participantAdded !== undefined) {
      obj.participantAdded = GroupParticipantAdded.toJSON(message.participantAdded);
    }
    if (message.participantRemoved !== undefined) {
      obj.participantRemoved = GroupParticipantRemoved.toJSON(message.participantRemoved);
    }
    if (message.participantLeft !== undefined) {
      obj.participantLeft = GroupParticipantLeft.toJSON(message.participantLeft);
    }
    if (message.iconChanged !== undefined) {
      obj.iconChanged = GroupIconChanged.toJSON(message.iconChanged);
    }
    if (message.iconRemoved !== undefined) {
      obj.iconRemoved = GroupIconRemoved.toJSON(message.iconRemoved);
    }
    return obj;
  },

  create(base?: DeepPartial<GroupChangeEvent>): GroupChangeEvent {
    return GroupChangeEvent.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GroupChangeEvent>): GroupChangeEvent {
    const message = createBaseGroupChangeEvent();
    message.chatGuid = object.chatGuid ?? "";
    message.occurredAt = object.occurredAt ?? undefined;
    message.actor = (object.actor !== undefined && object.actor !== null)
      ? SingleServiceAddressInfo.fromPartial(object.actor)
      : undefined;
    message.isFromMe = object.isFromMe ?? false;
    message.displayNameChanged = (object.displayNameChanged !== undefined && object.displayNameChanged !== null)
      ? GroupDisplayNameChanged.fromPartial(object.displayNameChanged)
      : undefined;
    message.participantAdded = (object.participantAdded !== undefined && object.participantAdded !== null)
      ? GroupParticipantAdded.fromPartial(object.participantAdded)
      : undefined;
    message.participantRemoved = (object.participantRemoved !== undefined && object.participantRemoved !== null)
      ? GroupParticipantRemoved.fromPartial(object.participantRemoved)
      : undefined;
    message.participantLeft = (object.participantLeft !== undefined && object.participantLeft !== null)
      ? GroupParticipantLeft.fromPartial(object.participantLeft)
      : undefined;
    message.iconChanged = (object.iconChanged !== undefined && object.iconChanged !== null)
      ? GroupIconChanged.fromPartial(object.iconChanged)
      : undefined;
    message.iconRemoved = (object.iconRemoved !== undefined && object.iconRemoved !== null)
      ? GroupIconRemoved.fromPartial(object.iconRemoved)
      : undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

function toTimestamp(date: Date): Timestamp {
  const seconds = Math.trunc(date.getTime() / 1_000);
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): Date {
  let millis = (t.seconds || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === "string") {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create(base?: DeepPartial<T>): T;
  fromPartial(object: DeepPartial<T>): T;
}
